<script setup lang="ts">
import { ref, onMounted } from "vue";

const images = import.meta.glob("@img/marquesina_*.svg", {
  eager: true,
  import: "default",
});

const bgImage = ref<string>("");

onMounted(() => {
  const couponCode = localStorage.getItem("couponCode") || "";
  const path = `/website/frontend/assets/img/marquesina_${couponCode}.svg`;

  bgImage.value =
    images[path] || images["/src/website/frontend/assets/img/marquesina.svg"];
});
</script>

<template>
  <div class="marquesina-container">
    <div
      class="pill pill--green-bold pill--medium marquesina"
      :style="{ backgroundImage: `url(${bgImage})` }"
    />
  </div>
</template>

<style scoped lang="scss">
.marquesina-container {
  padding: 0;
}

.marquesina {
  width: 100%;
  height: calc(38px + 4px);
  overflow: hidden;
  background-image: url("@img/marquesina.svg");
  background-repeat: repeat-x;
  background-size: 1623px 20px;
  background-position-y: center;
  animation: moveImage 20s linear infinite;
  padding: 1em;
}

@keyframes moveImage {
  0% {
    background-position-x: 0;
  }

  100% {
    background-position-x: -1623px;
  }
}
</style>
